import { render, staticRenderFns } from "./FantasyMarket.vue?vue&type=template&id=ddf9d38c&"
import script from "./FantasyMarket.vue?vue&type=script&lang=js&"
export * from "./FantasyMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports